export default {
  label: {
    noPostsLabel: 'No posts found',
  },
};
